import angular from 'angular';

export default function toTimeShort(toTimeFilter) {
  'ngInject';

  return function link(date) {
    let string = toTimeFilter(date);
    if (string && angular.isString(string)) {
      string = string.replace(' AM', 'A').replace(' PM', 'P');
    }

    return string;
  };
}
